package com.islamicmedia.shared.platform

import kotlinx.browser.window

actual fun triggerLightHaptic() {
    try {
        // navigator.vibrate works on Android Chrome / Edge mobile and is a no-op on iOS Safari
        // and most desktop browsers — we fire-and-forget either way.
        val nav = window.navigator.asDynamic()
        nav.vibrate?.invoke(8)
    } catch (_: Throwable) {}
}
